import React from 'react';
import AppRouter from './router';

/**
 * Main App component that renders the application router
 * @returns {React.ReactElement} App component
 */
function App() {
  return <AppRouter />;
}

export default App;